export const FILTER_I18N_PREFIX = "features.home.components.filter";

export const FILTER_I18N_KEYS = {
  all_sources_label:       "all_sources_label",
  facebook_category_label: "facebook_category_label",
  forums_category_label:   "forums_category_label"
}


// WEBPACK FOOTER //
// ./src/features/home/components/constants/i18n/Filteri18nConstants.js